import { useRecoilValueLoadable } from 'recoil'
import { MFSIPs } from '../../store/AdminStore'
import MFOrdersSkeleton from '../../Components/SkeletonLoaders/MFOrdersSkeleton'
import SIPTable from './SIPTable'
import SIPsEmpty from '../../Components/EmptyState/SIPsEmpty'

const UserSIPs = ({ clientCode }) => {
  const userSIPs = useRecoilValueLoadable(MFSIPs(clientCode))
  const parseSIPs = userSIPs?.state === 'hasValue' && JSON.parse(userSIPs?.contents?.data)
  const sips = parseSIPs?.data || []

  if (sips.length === 0) {
    return (
      <div className='bg-white flex items-center justify-center'>
        <SIPsEmpty
          title='No SIPs Found'
          description='No SIPs found for this client code'
          mainText='No SIPs found'
          page='SIPs'
          showButton={false}
        />
      </div>
    )
  }

  switch (userSIPs.state) {
    case 'loading':
      return (
        <div className='max-w-[1128px] mx-auto'>
          <MFOrdersSkeleton />
        </div>
      )

    case 'hasValue':
      return (
        <div className='bg-white min-h-screen'>
          <SIPTable sips={sips} clientCode={clientCode} />
        </div>
      )

    case 'hasError':
      return (
        <div className='bg-white flex items-center justify-center'>
          <SIPsEmpty
            title='No SIPs Found'
            description='No SIPs found for this client code'
            mainText='No SIPs found'
            page='SIPs'
            showButton={false}
          />
        </div>
      )
  }
}

export default UserSIPs
